<template>
    <el-container>
        <el-main>
            <!-- <div id="dialogs">
                <el-dialog :title="showDeatilsTitle" :visible.sync="showDeatils" :close-on-click-modal=false :before-close="handleDialogClose">
                    <el-form ref="logForm"  :model="formData" label-width="100px"  class="demo-ruleForm">
                        <el-form-item label="操作人" prop="commodityName">
                            <el-input v-model="formData.commodityName"  placeholder="操作人" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label="是否第一次点击" prop="isFirstClick">
                            <el-input v-model="formData.isFirstClick"  placeholder="是否第一次点击" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label=" IP/Email" prop="ipEmail">
                            <el-input v-model="formData.ipEmail"  placeholder=" IP/Email" :disabled="isUpdate"></el-input>
                        </el-form-item>
                         <el-form-item label="点击时间" prop="clickTime">
                            <el-input v-model="formData.clickTime"  placeholder="点击时间" :disabled="isUpdate"></el-input>
                        </el-form-item>
                        <el-form-item  label="操作描述" prop="optDescription">
                            <el-input type="textarea" :rows="6"  v-model="formData.optDescription"  :disabled="isUpdate"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="handleDialogClose">关 闭</el-button>
                    </div>
                </el-dialog>
            </div> -->
            <el-form :model="searchData" label-position="top" label-width="80px">
                <el-row :gutter="0">
                    <el-col :span="4">
                        <el-form-item label="课程名称" prop="commodityName" class="cls-col">
                            <el-input v-model="searchData.commodityName" placeholder="课程名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="是否第一次点击" prop="isFirstClick"  class="cls-col">
                            <el-select v-model="searchData.isFirstClick" placeholder="是否第一次点击" size="small">
                                <el-option label="不是" :value="0"></el-option>
                                <el-option label="是" :value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                  <el-col :span="4">
                    <el-form-item label="点击时间开始" prop="clickTime1" class="cls-col">
                      <!-- <el-input v-model="searchData.createTimeStart" placeholder="点击时间开始" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.clickTime1"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="点击时间结束" prop="clickTime2" class="cls-col">
                      <!-- <el-input v-model="searchData.createTimeEnd" placeholder="点击时间结束" size="small"></el-input> -->
                      <el-date-picker
                          v-model="searchData.clickTime2"
                          type="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-form-item>
                    <el-button type="primary" size="small" plain @click="search()">查询</el-button>
                </el-form-item>
            </el-form>           
            <el-table
                    :data="modelData"
                    border
                    highlight-current-row
                    v-loading="loading"
                    style="width: 100%"
                     @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="index"
                        label="序号"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="commodityName"
                        label="课程名称"
                        align="center"
                >
                </el-table-column>

                <el-table-column
                        prop="ipEmail"
                        label="IP/Email"
                >
                </el-table-column>
                <el-table-column
                        prop="clickTime"
                        label="点击时间"
                        :formatter="dateFormat"
                >
                </el-table-column>
                
                <el-table-column
                    label="是否第一次点击"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isFirstClick == 0">否</span>
                        <span v-else>是</span>
                    </template>
                </el-table-column>
            </el-table>
           <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
    import https from '@/https.js'
    import {dateFormat} from '@/api/utils.js'
    const formData = {
        logId: "",
        commodityName: "",
        isFirstClick: "",
        optDescription: "",
        clickTime: "",
        ipEmail: ""
    };
    export default {
        name: "log",
        components: {            
        },
        data() {           
            return {
                modelData:[],
                rules: {
                },              
                searchData: {
                    commodityName: null,
                    isFirstClick: null,
                    ipEmail: null,
                    createTimeStart: null,
                    createTimeEnd: null,
                    page: 0,
                    size: 10
                },         
                pageSize:10,
                loading: false,
                total: 0,
                multipleSelection : [],
                _logId: "",
                showDeatilsTitle: "",
                showDeatils:false,
                checkedKeys: [],
                currentPage: 1,
                isUpdate: true,
                formData:""
            }
        },
        methods: {   
             handleDialogClose() {
                 let that = this;
                that.showDeatils = false;
            }, 
            handleSizeChange() {
            },
            handleCurrentChange(val) {
                this.search(val);
            },
            handleSelectionChange(val) {
                this.multipleSelection = [];
                for(let index in val) {
                    this.multipleSelection[index] =  val[index].logId;
                }
            },
            showDetails(index, row){
                row.clickTime = dateFormat(row.clickTime);
                this.formData = JSON.parse(JSON.stringify(row));
                this.showDeatilsTitle = "日志详情";
                this.showDeatils=true;  
            },          
            search(val) {
                console.log(val,'val');
               this.searchData.size = this.pageSize;
               console.log('this.searchData.size',this.searchData.size);
                if(val) {
                    this.searchData.page = val;
                } else {
                    this.searchData.page = 1;
                    this.currentPage = 1;
                }
                if(this.searchData.clickTime1){
                    this.searchData.createTimeStart=this.searchData.clickTime1+" 00:00:00";
                }
                else{
                    this.searchData.createTimeStart=null;
                }
                if(this.searchData.clickTime2){
                    this.searchData.createTimeEnd=this.searchData.clickTime2+" 23:59:59";
                }
                else{
                    this.searchData.createTimeEnd=null;
                }

                let params = this.searchData;
                console.log('param',params);
                  https.fetchPost('/click/searchClickStatistic',JSON.parse(JSON.stringify(params)),"json" ).then((data) => {
                    let code = data.data.code;
                    if(code == '200') {
                        this.modelData = data.data.data.list;
                        console.log(' this.modelData', this.modelData);
                        this.total = data.data.data.total;
                        this.loading = false;
                    }
                }).catch(err=>{
                        console.log(err)
                    }
                )
            },
            dateFormat(row, column, cellValue, index) {
                if(cellValue != null) {
                    return dateFormat(cellValue);
                } else {
                    return cellValue
                }
            }             
        },
        created: function () {
            this.search(1);
        }
    }
</script>

<style scoped>
.add-button {
    margin-bottom: 5px;
}
.but-cls {
    margin-bottom: 10px;
}
.cls-col {
    margin-right: 20px;
}
.el-input.is-disabled .el-input__inner,.el-input.is-disabled .el-textarea__inner{
    color:#000;
}
</style>